"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'limits.upgrade.message': '升级您的账户计划以访问此功能。',
    'limits.upgrade.link': '立即升级',
};
